'use client';

import { Suspense } from 'react';
import dynamic from 'next/dynamic';
import { useRightPanel } from '@/contexts/RightPanelContext';
import RightPanel from './RightPanel';
import { Loader2 } from 'lucide-react';

// Lazy load components for better performance
const AppointmentPanelContent = dynamic(() => import('./AppointmentPanelContent'), {
  loading: () => (
    <div className="flex items-center justify-center py-12">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  ),
});

const DiagnosticsPanelContent = dynamic(() => import('./DiagnosticsPanelContent'), {
  loading: () => (
    <div className="flex items-center justify-center py-12">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  ),
});

const AdminAppointmentManagement = dynamic(() => import('./AdminAppointmentManagement'), {
  loading: () => (
    <div className="flex items-center justify-center py-12">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  ),
});

export default function RightPanelContent() {
  const { isOpen, content, closePanel } = useRightPanel();

  const getTitle = () => {
    switch (content) {
      case 'appointments':
        return 'Book Appointment';
      case 'diagnostics':
        return 'System Diagnostics';
      case 'admin-appointments':
        return 'Appointment Management';
      default:
        return '';
    }
  };

  const getPanelWidth = () => {
    switch (content) {
      case 'admin-appointments':
        return 'w-full md:w-[900px] lg:w-[1000px]';
      default:
        return 'w-full md:w-[600px] lg:w-[700px]';
    }
  };

  const renderContent = () => {
    switch (content) {
      case 'appointments':
        return <AppointmentPanelContent onClose={closePanel} />;
      case 'diagnostics':
        return <DiagnosticsPanelContent onClose={closePanel} />;
      case 'admin-appointments':
        return <AdminAppointmentManagement />;
      default:
        return null;
    }
  };

  if (!content) return null;

  return (
    <RightPanel isOpen={isOpen} onClose={closePanel} title={getTitle()} width={getPanelWidth()}>
      <Suspense fallback={
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
      }>
        {renderContent()}
      </Suspense>
    </RightPanel>
  );
}

